export enum Title {
  SPECIAL_CHARTS = 'Special Charts'
}
